import script from "./StaffServiceCont.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffServiceCont.vue?vue&type=script&setup=true&lang=js"

import "./StaffServiceCont.vue?vue&type=style&index=0&id=75b3af18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b3af18"]])

export default __exports__